import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CompetitionCalendarAndResultsQuery } from '../types';

/**
 * typeguard for CompetitionCalendarAndResultsQuery
 * @param CompetitionCalendarAndResultsQuery object passed to transformer
 */
export const isValidCompetitionCalendarAndResults = (obj: CompetitionCalendarAndResultsQuery): boolean => Boolean(obj?.data?.competitionCalendarAndResults && !isEmptyObject(obj.data.competitionCalendarAndResults));
